import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Upload } from 'lucide-react';
import { LoanDocument } from '../types';
interface DocumentItemProps {
  document: LoanDocument;
  onToggle: (id: string) => void;
  onUpload: (id: string, file: File) => void;
}
export function DocumentItem({
  document,
  onToggle,
  onUpload
}: DocumentItemProps) {
  const isComplete = document.status !== 'pending';
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleUploadClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    fileInputRef.current?.click();
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      onUpload(document.id, e.target.files[0]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  return <motion.div layout initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} onClick={() => onToggle(document.id)} className={`
        flex items-center py-3 px-4 rounded-lg cursor-pointer select-none transition-all duration-200
        ${isComplete ? 'bg-green-50/50' : 'bg-white hover:bg-gray-50'}
      `} data-id="element-13">
      <div className={`
          w-6 h-6 rounded-md flex items-center justify-center mr-3 flex-shrink-0 border-2 transition-all duration-200
          ${isComplete ? 'bg-green-600 border-green-600 text-white' : 'border-gray-300 text-transparent hover:border-green-400'}
        `} data-id="element-14">
        <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-15" />
      </div>

      <div className="flex-1 min-w-0" data-id="element-16">
        <h4 className={`text-sm font-medium transition-colors duration-200 ${isComplete ? 'text-slate-500 line-through' : 'text-slate-900'}`} data-id="element-17">
          {document.name}
        </h4>
        {isComplete && document.fileName && <p className="text-xs text-slate-400 mt-0.5 truncate" data-id="element-18">
            {document.fileName}
          </p>}
      </div>

      <input type="file" ref={fileInputRef} onChange={handleFileChange} className="hidden" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" data-id="element-19" />
      <button onClick={handleUploadClick} className="ml-3 flex items-center px-3 py-1.5 text-xs font-medium text-green-700 bg-green-100 hover:bg-green-200 rounded-md transition-colors flex-shrink-0" data-id="element-20">
        <Upload className="w-3.5 h-3.5 mr-1.5" data-id="element-21" />
        Upload
      </button>
    </motion.div>;
}